import { Provider } from "@redotech/redo-model/order";
import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  platformFromModel,
  validatePlatformCondition,
  type PlatformState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const platformMap = new Map<Provider, string>();
platformMap.set(Provider.SHOPIFY, "Shopify");
platformMap.set(Provider.COMMENTSOLD, "Comment Sold");
platformMap.set(Provider.COMMERCE_CLOUD, "Commerce Cloud");

export const PLATFORM = (
  Details: React.ComponentType<ConditionTypeDetailsProps<PlatformState>>,
): ConditionType<PlatformState, Condition.Platform> => ({
  name: "Platform",
  description(state) {
    return state
      ? `Platform: ${platformMap.get(state)}`
      : "The e-commerce platform where the order was placed (Shopify, BigCommerce, etc.)";
  },
  Details(props: ConditionTypeDetailsProps<PlatformState>) {
    return React.createElement(Details, props);
  },
  empty: null,
  fromModel(model) {
    return platformFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PLATFORM, method: state };
  },
  valid(state) {
    return validatePlatformCondition(state).valid;
  },
});

export { type PlatformState } from "@redotech/redo-model/return-flow/condition-validate";
